<template>
    <div class="porque">
        <div class=" color-blanco" :style="'background-image: url(https://nncms.actstudio.xyz/'+neutral.cover.path+')'" style="background-size: cover; position: relative;">
            <div style="background: rgb(90, 35, 178); background: linear-gradient(0deg, rgba(90, 35, 178, 0.3) 1%,rgba(90, 35, 178, 0.5452381636248249) 52%,rgba(90, 35, 178, 1) 100%);" >  
                <v-container>
                    <v-row class="py-10" justify="center">
                        <v-col class="text-center" cols="12">
                            <span class="d-block mb-5 regular-size">¿Por qué Neutral Networks?</span>
                            <span class="montserrat bold enfasis-size">Nuestra diferencia</span>
                            
                        </v-col>
                        <v-col cols="10" sm="6">
                            <hr style="width: 100%; color:#FFF;">
                        </v-col>
                    </v-row>
                    <v-row  style="height: 168px" justify="center">

                        <v-col cols="12" md="4" class="text-center py-0" v-for="difference in neutral.nuestraDiferencia" :key="difference">
                            <span class="montserrat bold enfasis-size valign-middle">{{difference.value}}</span>
                        </v-col>
                        
                    </v-row>

                    <v-row align="start"  style="height: 168px" justify="center" class="pa-0">
                        <v-col cols="10" sm="8" md="6" class="pa-0 text-center">
                            <hr class="mb-5"  style="width: 100%; color:#FFF;">
                            <span class="titulos-size bold">Equivale a posibilidades ilimitadas para tu empresa</span>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>
        
        <div >
            
            <v-container>
                <v-row class="pt-10 d-none d-sm-flex" >
                    <v-col class="pa-0" style="border-bottom:1px solid #5c27b2" v-for="(item, index) in neutral.slides" :key="'titulo-'+index">
                        <div class="selectionTab pb-2 mr-4 color-morado-2" v-bind:class="{'selected':indexSlide==index}" @click="indexSlide=index">
                            <span class="enfasis-size d-block mb-3">{{index + 1}}</span>
                            <span class="texto-corrido-card-size d-block">{{item.value.titulo}} </span>
                        </div>
                    </v-col>
                </v-row>
                


                <v-row class="pt-10">
                        <div style="position:relative; width:100%;">

                            <div style="position:absolute; top:46%; left:4%; z-index:1; transform:translateY(-50%)" @click="prevSlide()">        
                                <v-img src="../assets/img/left_slide.svg" height="30"></v-img>
                                    
                            </div>
                                
                            <div style="position:absolute; top:46%; right:4%; z-index:1; transform:translateY(-50%)" @click="nextSlide()">
                                <v-img src="../assets/img/right_slide.svg" height="30"></v-img>
                            </div>

                            <v-col class="px-16">
       
                                <v-carousel :show-arrows="false" hide-delimiters v-model="indexSlide" height="700"> 
                                    
                                    <v-carousel-item v-for="(item, index) in neutral.slides" :key="index" > 
                                        <v-row v-if="index%2==0" class="color-morado-2 d-none d-sm-flex">
                                            <v-col cols="12" sm="6" md="5" >
                                                <v-img :src="'https://nncms.actstudio.xyz/'+item.value.imagen.path" width="auto" height="100%"></v-img>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6" class="pa-8">
                                                <span class="d-block mb-4 enfasis-size">{{index + 1}}</span>
                                                <span class="titulos-size bold d-block mb-8">{{item.value.subtitulo}}</span>
                                                <span class="single-item-size d-block ">{{item.value.descripcion}}</span>
                                                
                                            </v-col>
                                        </v-row>
                                        <v-row v-else class="color-morado-2 d-none d-sm-flex">
                                            <v-col cols="12" sm="6" md="6"  class="pa-8">
                                                <span class="d-block mb-4 enfasis-size">{{index + 1}}</span>
                                                <span class="titulos-size bold d-block mb-8">{{item.value.subtitulo}}</span>
                                                <span class="single-item-size d-block ">{{item.value.descripcion}}</span>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="5">
                                                <v-img :src="'https://nncms.actstudio.xyz/'+item.value.imagen.path" width="auto" height="100%"></v-img>
                                            </v-col>

                                        </v-row>
                                        <v-row  class="color-morado-2 d-flex d-sm-none">
                                            <v-col cols="12" sm="5" md="5" >
                                                <v-img :src="'https://nncms.actstudio.xyz/'+item.value.imagen.path" width="auto" height="auto"></v-img>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6" class="py-8 px-3">
                                                <span class="d-block mb-4 enfasis-size">{{index + 1}}</span>
                                                <span class="titulos-size bold d-block mb-8">{{item.value.subtitulo}}</span>
                                                <span class="single-item-size d-block ">{{item.value.descripcion}}</span>
                                                
                                            </v-col>
                                        </v-row>
                                    </v-carousel-item>
                                  
                                        
                                </v-carousel>
                        
                            </v-col>
                        </div>
                </v-row>
                
            </v-container>
        </div>

        <div class="content-background-2">
            <v-container >
                <v-row >
                    <v-col class="py-4 py-sm-14 px-6" cols="12" sm="6" md="6" v-for="(item, index) in neutral.info" :key="'val-'+index">
                        <p class="titulos-size bold" v-if="index%2==0">
                            {{item.value}}
                        </p>
                        <p class="single-item-size " v-else>
                            {{item.value}}
                        </p>
                        
                    </v-col>
                    

                </v-row>

            
            </v-container>
        </div>

        <div class="atencion">
            <v-container style="color:#5C27B2;" class="py-16">
                <v-row class="pb-7">
                    <v-col class="text-center">
                        <span class="titulos-size bold"> Tenemos una línea abierta <br> de atención </span>
                        <span class="titulos-size d-inline-block">24/7</span>
                    </v-col>
                </v-row>
                <v-row justify="center">

                    
                    <v-col  cols="12" sm="5" md="5" class="text-center ">
                        
                        <span class="d-block">Monterrey</span>
                        <v-img src="../assets/img/telefonos-nn-1.svg" width="15" class="d-inline-block mr-2" style="vertical-align: -10%;"></v-img>
                        <span class="d-inline-block subtitulo-bold">+52(81) 2165 8060</span>
                        
                    </v-col>

                </v-row>
            </v-container>
        </div>
    </div>
</template>
<script>
export default {
    data () {
      return {
        tab: null,
        neutral:[],
        isActive:null,
        indexSlide:0,
        
      }
    },
    mounted: function(){
        fetch('http://nncms.actstudio.xyz/api/singletons/get/PorqueNeutral?token=8cf7ca41761951fdde0c1e2cfda401')
        .then(data => data.json())
        .then(data => this.neutral = data);
        },
    methods:{
        nextSlide:function(){
            if (this.indexSlide == this.neutral.slides.length-1){
                
                this.indexSlide = 0;
            }else{
                this.indexSlide++;
            }
        },
        prevSlide:function(){
            console.log('tamano '  +  this.neutral.slides.length-1);
            if (this.indexSlide == 0){
                this.indexSlide = this.neutral.slides.length-1;
            }else {
                this.indexSlide--;
            }
        }

    }
}
</script>